var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDxc = function SvgDxc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.525,
    height: 19.188,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dxc_svg__a)",
    d: "M25.364 0c5.238 0 9.502 4.303 9.502 9.594s-4.264 9.594-9.502 9.594H0v-3.916h25.364c3.104 0 5.63-2.548 5.63-5.678s-2.526-5.678-5.63-5.678H0V0zm92.161 3.916H92.162c-3.105 0-5.63 2.548-5.63 5.678s2.525 5.678 5.63 5.678h25.363v3.916H92.162c-5.241 0-9.503-4.303-9.503-9.594S86.923 0 92.162 0h25.363zm-38.574 0c-4.145 0-7.055 1.854-10.137 3.817-1 .638-2.013 1.28-3.07 1.854 1.056.574 2.07 1.216 3.07 1.854 3.082 1.963 5.992 3.817 10.138 3.817v3.916c-5.264 0-8.95-2.347-12.202-4.418-2.703-1.72-5.038-3.209-7.898-3.209-2.861 0-5.196 1.486-7.9 3.209-3.252 2.07-6.937 4.418-12.2 4.418v-3.916c4.145 0 7.056-1.854 10.137-3.817 1-.638 2.014-1.28 3.07-1.854-1.056-.574-2.07-1.216-3.07-1.854-3.081-1.963-5.992-3.817-10.137-3.817V0c5.263 0 8.948 2.347 12.2 4.42 2.704 1.721 5.039 3.21 7.9 3.21v-.003c2.86 0 5.195-1.486 7.898-3.209C70.003 2.348 73.688 0 78.951 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.364 0c5.238 0 9.502 4.303 9.502 9.594s-4.264 9.594-9.502 9.594H0v-3.916h25.364c3.104 0 5.63-2.548 5.63-5.678s-2.526-5.678-5.63-5.678H0V0zm92.161 3.916H92.162c-3.105 0-5.63 2.548-5.63 5.678s2.525 5.678 5.63 5.678h25.363v3.916H92.162c-5.241 0-9.503-4.303-9.503-9.594S86.923 0 92.162 0h25.363zm-38.574 0c-4.145 0-7.055 1.854-10.137 3.817-1 .638-2.013 1.28-3.07 1.854 1.056.574 2.07 1.216 3.07 1.854 3.082 1.963 5.992 3.817 10.138 3.817v3.916c-5.264 0-8.95-2.347-12.202-4.418-2.703-1.72-5.038-3.209-7.898-3.209-2.861 0-5.196 1.486-7.9 3.209-3.252 2.07-6.937 4.418-12.2 4.418v-3.916c4.145 0 7.056-1.854 10.137-3.817 1-.638 2.014-1.28 3.07-1.854-1.056-.574-2.07-1.216-3.07-1.854-3.081-1.963-5.992-3.817-10.137-3.817V0c5.263 0 8.948 2.347 12.2 4.42 2.704 1.721 5.039 3.21 7.9 3.21v-.003c2.86 0 5.195-1.486 7.898-3.209C70.003 2.348 73.688 0 78.951 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dxc_svg__b)",
    d: "M25.364 0c5.238 0 9.502 4.303 9.502 9.594s-4.264 9.594-9.502 9.594H0v-3.916h25.364c3.104 0 5.63-2.548 5.63-5.678s-2.526-5.678-5.63-5.678H0V0zm92.161 3.916H92.162c-3.105 0-5.63 2.548-5.63 5.678s2.525 5.678 5.63 5.678h25.363v3.916H92.162c-5.241 0-9.503-4.303-9.503-9.594S86.923 0 92.162 0h25.363zm-38.574 0c-4.145 0-7.055 1.854-10.137 3.817-1 .638-2.013 1.28-3.07 1.854 1.056.574 2.07 1.216 3.07 1.854 3.082 1.963 5.992 3.817 10.138 3.817v3.916c-5.264 0-8.95-2.347-12.202-4.418-2.703-1.72-5.038-3.209-7.898-3.209-2.861 0-5.196 1.486-7.9 3.209-3.252 2.07-6.937 4.418-12.2 4.418v-3.916c4.145 0 7.056-1.854 10.137-3.817 1-.638 2.014-1.28 3.07-1.854-1.056-.574-2.07-1.216-3.07-1.854-3.081-1.963-5.992-3.817-10.137-3.817V0c5.263 0 8.948 2.347 12.2 4.42 2.704 1.721 5.039 3.21 7.9 3.21v-.003c2.86 0 5.195-1.486 7.898-3.209C70.003 2.348 73.688 0 78.951 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "dxc_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(64.172 -18.3125 7.82855 28.0593 59.161 9.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#FEA15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#FF7E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B88A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6399F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dxc_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(113.641 -7.59114 10.0272 22.734 -2.35 15.657)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#FEA15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#FF7E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B88A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6399F0"
  })))));
};
export default SvgDxc;